const moduleKey = 'ADMIN_MODULE';

export const adminTypes = {
  LOAD_REQUESTED: moduleKey + "_LOAD_REQUESTED",
  LOADED: moduleKey + "_LOADED",
  SET_TABLE_CONFIG: moduleKey + "_SET_TABLE_CONFIG",
  SET_TABLE_CONFIG_FILTER: moduleKey + "_SET_TABLE_CONFIG_FILTER",
  CHANGE_TAB: moduleKey + '_CHANGE_TAB',
  CLOSE_TAB: moduleKey + '_CLOSE_TAB',
  CREATE_TAB: moduleKey + '_CREATE_TAB',
  GET_DETAIL_REQUESTED: moduleKey + '_GET_DETAIL_REQUESTED',
  GET_DETAIL_LOADED: moduleKey + '_GET_DETAIL_LOADED',
  UPDATE_SUCCESS: moduleKey + '_UPDATE_SUCCESS',
  VERIFY_ACCOUNT: moduleKey + '_VERIFY_ACCOUNT'
};

export const adminActions = {
  loadRequested: (tableConfig) => ({ type: adminTypes.LOAD_REQUESTED, tableConfig }),
  loaded: (data) => ({ type: adminTypes.LOADED, payload: { data } }),
  setTableConfig: (key, value) => ({ type: adminTypes.SET_TABLE_CONFIG, key, value }),
  setTableConfigFilter: (key, value) => ({ type: adminTypes.SET_TABLE_CONFIG_FILTER, key, value }),
  changeTab: (key) => ({ type: adminTypes.CHANGE_TAB, key }),
  closeTab: (key) => ({ type: adminTypes.CLOSE_TAB, key }),
  createTab: (key, title) => ({ type: adminTypes.CREATE_TAB, key, title }),
  getDetail: (id, index) => ({ type: adminTypes.GET_DETAIL_REQUESTED, id, index }),
  getDetailLoaded: (data, index) => ({ type: adminTypes.GET_DETAIL_LOADED, payload: { data }, index }),
  updateSuccess: (index) => ({ type: adminTypes.UPDATE_SUCCESS, index }),
  verifyAccount: (token) => ({ type: adminTypes.VERIFY_ACCOUNT, token }),
};
